const dragDropFile = {
  upload: {
    drag: 'Solte seu arquivo aqui ou',
    browse: 'procurar seus arquivos.',
  },

  uploaded: {
    success: 'O arquivo {{name}} foi carregado com sucesso',
    chooseAnotherFile: 'Escolha um arquivo diferente.',
  },
};

export default dragDropFile;
